// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ChevronRightComponent} from './ChevronRight.svg';

import Icon, { TIconProps } from '../Icon';

export const IconChevronRight = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ChevronRightComponent/>
  </Icon>
));
